import Query from '../../../components/Report';

const query = new Query('search-urls-directories');

export default query;
